import React from 'react';
import '../styles/residentialComponent.css';

const ResidentialComponent = ({ 
  title = "Beautiful Landscaping that Fits Your Lifestyle",
  description = "All Seasons excels in producing superior landscapes from initial design to installation. From start to finish and beyond, our exceptional construction and maintenance teams keep new as well as old installations looking new and well kept.",
  features = [
    "Superior landscape design & installation",
    "Professional landscape plans",
    "High-end residential remodels",
    "Commercial landscape installations",
    "Year-round maintenance services"
  ],
  images = [], // Array of image objects: {src: '', alt: ''}
  size = "large", // "large" or "small"
  variant = "default", // "default", "editorial", "architectural"
  showNumbers = false, // Show subtle numbering
  accentBackground = false, // Add subtle background accent
  ctaText = "", // CTA button text for small variant
  ctaLink = "" // CTA button link for small variant
}) => {
  const componentClass = `
    residential-component 
    residential-component--${size} 
    ${variant !== 'default' ? `residential-component--${variant}` : ''}
    ${accentBackground ? 'residential-component--subtle-accent' : ''}
  `.trim().replace(/\s+/g, ' ');
  
  return (
    <section className={componentClass}>
      <div className="residential-component__container">
        <div className="residential-component__content">
          <div className="residential-component__header">
            <h2 className="residential-component__title">{title}</h2>
            <p className="residential-component__description">{description}</p>
          </div>
          
          <ul className="residential-component__features">
            {features.map((feature, index) => (
              <li 
                key={index} 
                className="residential-component__feature"
                data-number={showNumbers ? `0${index + 1}` : ''}
              >
                {feature}
              </li>
            ))}
          </ul>
          
          {size === "small" && ctaText && ctaLink && (
            <a href={ctaLink} className="residential-component__cta btn-primary">
              {ctaText}
            </a>
          )}
        </div>
        
        {images.length > 0 && size === "large" && (
          <div className="residential-component__floating-images">
            {images.map((image, index) => (
              <div key={index} className={`residential-component__floating-image residential-component__floating-image--${index + 1}`}>
                <img src={image.src} alt={image.alt || `Landscaping image ${index + 1}`} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ResidentialComponent;